import {reduxForm} from 'redux-form';
import config from 'config';
import FromComponent from './VideoOnDemandEditForm';
import {STREAM_ROUTER_VOD} from '../constants';
import {vodAction} from '../../../../actions/vod';
import {validateRedux, validateAsyncRedux} from '../../../../utilites/validate';
import {push} from 'react-router-redux/lib/actions';
import {withRouter} from 'react-router';

let CRUDActions = vodAction;

const validate = (data, { video_categories }) => {
  let validationParams = {
    title:{
      presence: {
        message: '^Title is missing'
      }
    },
    category_id: video_categories.list.length ? {
      presence: {
        message: '^Category is missing'
      }
    } : {},
    video: {
      presence: {
        message: '^Please upload a video'
      },
      vodVideo: true
    },
    description: {
      presenceContent: {
        message: '^Description is missing'
      }
    },
    countries: {
      presence: {
        message: '^Countries is missing'
      }
    }
  };

  return validateRedux(data, validationParams);
};

const asyncValidate = (data) => validateAsyncRedux(data, {
  logo: {
    presence: {message: '^Please upload an image'},
    minImageSizeAsync: config.streamCrop
  }
});

export default withRouter(reduxForm(
  {
    form: 'vod_edit_form',
    fields: [
      'title',
      'video',
      'logo',
      'description',
      'vip_only',
      'countries',
      'category_id',
      'trigger_push_notifications',
      'push_notifications_triggered',
      'order_number'
    ],
    returnRejectedSubmitPromise: true,
    asyncBlurFields: ['logo'],
    model: {},
    asyncValidate,
    validate
  },
  ({ video_categories, vod: { model = {} } }, {location: { query: { category_id } }}) => ({
    model,
    video_categories,
    isPublished: model && model.isPublished && model.published,
    initialValues: model
      ? {
        title: model.title,
        video: model.video,
        logo: model.logo,
        vip_only: model.vip_only,
        description: model.description,
        countries: model.countries,
        category_id: model.category_id || category_id,
        order_number: model.order_number,
        trigger_push_notifications: model.id ? false : true,
        push_notifications_triggered: model.push_notifications_triggered,
      }
      : {}
  }),
  dispatch => ({
    publish: (item, data) => dispatch(CRUDActions.publish(item, data)),
    onClose: (category_id) => {
      dispatch(push(category_id ? STREAM_ROUTER_VOD + '/category/'+ category_id: STREAM_ROUTER_VOD));
      dispatch(CRUDActions.onCloseEditForm());
    }
  })
)(FromComponent));




// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/VideoOnDemandEditForm/index.js